<template>
  <table>
    <table-blue-head :cols="cols" />
    <tbody>
      <slot />
    </tbody>
  </table>
</template>

<script>
  import TableBlueHead from './TableBlueHead';

  export default {
    name: "TableBlue",
    props: ['cols'],
    components: {
      TableBlueHead,
    },
  }
</script>

<style scoped>
  table {
    border-bottom: 1px solid #D1D1D1;
    background-color: #D1D1D1;
    width: 100%;
    margin: 0 0 10px 0 !important;
    border-collapse: collapse;
    border-spacing: 0;
    padding: 0;
    font-size: 12px;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
    display: table;
    font-family: Verdana, sans-serif;
    color: #000;
  }

  tbody {
    margin: 0;
    padding: 0;
    border: 0;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
    display: table-row-group;
    border-collapse: collapse;
    border-spacing: 0;
    text-align: left;
    font-family: Verdana, sans-serif;
    font-size: 12px;
  }

  td {
    padding: 2px 4px 2px 4px !important;
    color: #333;
    vertical-align: middle;
  }

  .odd:hover {
    background: #C5DAE5;
  }

  .odd {
    background-color: #fff;
    margin: 0;
    padding: 0;
    border: 0;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
    display: table-row;
    border-collapse: collapse;
    border-spacing: 0;
    text-align: left;
    font-family: Verdana, sans-serif;
    font-size: 12px;
    color: #000;
  }

  .even {
    background-color: #EAECEA;
  }

  .even:hover {
    background: #C5DAE5;
  }

  .locked {
    background-color: #ffc8bd;
  }
</style>
